import { PopGames } from "../list/PopGames";
import Link from "next/link";

function myLoopPopular() {
  var myArray = [];
  var i;
  for (i = 0; i < PopGames.length; i++) {
    myArray[i] = (
      <li key={i} className="para description">
        <Link href={PopGames[i].path} prefetch={false} title={PopGames[i].name} passHref>
          {PopGames[i].name}
        </Link>
      </li>
    );
  }
  return myArray;
}
export default function PopularGames() {
  return (
    <div>
      <h2 className="contant name">Most popular games of the week </h2>
      <ul className="gamelist">{myLoopPopular()}</ul>

      
    </div>
  );
}
